// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as CustomerLogoutApiModel$PorterinFeature from "../api-model/CustomerLogoutApiModel.mjs";

function apiModelToState(model) {
  return {
          logout_success: model.logout_success
        };
}

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(CustomerLogoutApiModel$PorterinFeature.t_decode(json), "CustomerLogoutEntityMapper.res");
  return {
          logout_success: model.logout_success
        };
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
